<template>
    <div :class="{ 'header-fixed': fixed }" v-if="pageFrom!=='store' && !isTheme1 && !storeInfo.agent">
        <v-layout class="cookie-summary" align-center v-if="showCookie">
            <img :src="storeInfo.logo.url" v-if="storeInfo.logo" class="logo"/>
            <v-flex class="cookie-summary-info">
                {{ storeInfo.name }} {{ $t("nav.cookie") }}
            </v-flex>
            <v-flex shrink>
                <button class="button ok-button" @click="handleDownload">
                    {{ $t("nav.download") }}
                </button>
            </v-flex>
            <v-btn
                icon
                fab
                flat
                class="close-btn"
                @click="closeCookie"
                color="#fff"
                small
            >
                <v-icon>close</v-icon>
            </v-btn>
        </v-layout>
    </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";

export default {
    props: {
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showMenu: false,
            items: [{title: "Click Me"}, {title: "Click Me 2"}]
        };
    },
    computed: {
        ...mapState([
            "guid",
            "tokenContent",
            "userInfo",
            "showCookie",
            "isLogin",
            "language",
            "languages",
            "storeInfo",
            "pageFrom",
            "isTheme1",
        ]),
        languageIcon() {
            if (this.language.value == "zh-CN") {
                return require(`../../assets/China.png`);
            } else {
                return require(`../../assets/Spain.png`);
            }
        }
    },
    methods: {
        ...mapMutations(["closeCookie", "setLanguage"]),

        created() {
            console.log(this.storeInfo);
        },
        handleShowMenu() {
            this.showMenu = !this.showMenu;
        },
        hideShowMenu() {
            this.showMenu = false;
        },
        handleChangeLanguage(language) {
            this.setLanguage(language);
            this.$i18n.locale = language.value;
        },

        handleDownload() {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
            let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
            const storeConf = this.storeInfo && this.storeInfo.storeConf || {};

            debugger;
            if (isAndroid) {
                window.location.href =
                    storeConf.android_qrcode_link || "https://play.google.com/store/apps/details?id=com.technology.geat";
            } else if (isIOS) {
                window.location.href =
                    storeConf.ios_qrcode_link || "https://apps.apple.com/es/app/geat/id1466834290";
            }
        }
    }
};
</script>

<style scoped lang="sass" src="./navigation.sass"></style>
